import React from 'react';
import styles from './BrowserFrame.scss';
import { BrowserFrameHeader } from './BrowserFrameHeader';
export const BrowserFrame = _ref => {
  let {
    headerProps,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.browserFrame
  }, /*#__PURE__*/React.createElement(BrowserFrameHeader, headerProps), /*#__PURE__*/React.createElement("div", {
    className: styles.browserFrameContent
  }, children));
};
//# sourceMappingURL=BrowserFrame.js.map